// extracted by mini-css-extract-plugin
export var titleContainer = "DepartmentSection-module--titleContainer--N0A7L";
export var departmentContainer = "DepartmentSection-module--departmentContainer--l52hu";
export var lastDepartmentContainer = "DepartmentSection-module--lastDepartmentContainer--3R_-3";
export var featuredDepartmentContainer = "DepartmentSection-module--featuredDepartmentContainer--2IzcM";
export var listingsContainer = "DepartmentSection-module--listingsContainer--r3f2F";